/* unplugin-vue-components disabled */import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, mergeProps as _mergeProps } from "vue";
const _hoisted_1 = {
  class: "page_head"
};
const _hoisted_2 = {
  class: "item_box"
};
const _hoisted_3 = {
  key: 0,
  class: "btn_s"
};
const _hoisted_4 = ["src", "onClick"];
const _hoisted_5 = ["src", "onClick"];
const _hoisted_6 = ["src", "onClick"];
const _hoisted_7 = {
  key: 1
};
const _hoisted_8 = {
  key: 1
};
import { queryEvaluationTargetLevel, addEvaluationTargetLevel, editEvaluationTargetLevel, deleteEvaluationTargetLevel } from "@/api";
import { ElMessage } from "element-plus";
import { onActivated } from "vue";
import { box } from "@sunrise";
export default {
  __name: 'evaluationGradeSettings',
  setup(__props) {
    const getCCList = async () => {
      const {
        code,
        data
      } = await queryEvaluationTargetLevel();
      console.log(code, data);
      if (code == "success") {
        tableData.value = data.map(i => {
          i.isEdit = false;
          return i;
        });
      }
    };
    const addTarget = () => {
      if (tableData.value.length == 4) {
        ElMessage.warning("层次等级已达上线！");
        return;
      }
      for (const item of tableData.value) {
        if (item.isEdit) {
          ElMessage.warning("请先保存！");
          return;
        }
      }
      tableData.value.push({
        level: "",
        minScore: 0,
        maxScore: 0,
        levelName: "",
        isEdit: true
      });
    };
    const tableData = ref([]);
    const header = [{
      label: "等级",
      prop: "level"
    }, {
      label: "达标项下限",
      prop: "minScore"
    }, {
      label: "达标项上限",
      prop: "maxScore"
    }, {
      label: "描述",
      prop: "levelName"
    }, {
      label: "操作",
      prop: ""
    }];
    const editFn = row => {
      for (const item of tableData.value) {
        if (item.isEdit) {
          ElMessage.warning("请先保存！");
          return;
        }
      }
      row.isEdit = true;
    };
    const submitAdd = async row => {
      if (!!row.id) {
        //编辑
        const {
          code,
          data
        } = await editEvaluationTargetLevel(row);
        if (code == "success") {
          ElMessage.success("编辑成功！");
          getCCList();
        }
      } else {
        //新增
        const {
          code,
          data
        } = await addEvaluationTargetLevel(row);
        if (code == "success") {
          ElMessage.success("新增成功！");
          getCCList();
        }
      }
    };
    getCCList();
    const deleteItem = row => {
      box("你确认删除这条层次等级吗？", async () => {
        if (!!row.id) {
          const {
            code,
            data
          } = await deleteEvaluationTargetLevel({
            id: row.id
          });
          if (code == "success") {
            tableData.value = tableData.value.filter(i => !Object.is(row, i));
            ElMessage.success("删除成功！");
          }
        } else {
          tableData.value = tableData.value.filter(i => !Object.is(row, i));
          ElMessage.success("删除成功！");
        }
      }, "警告");
    };
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_head_title = _resolveComponent("head-title");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_table = _resolveComponent("el-table");
      return _openBlock(), _createElementBlock("main", _hoisted_1, [_createVNode(_component_head_title, {
        title: "评价等次设置"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_button, {
          type: "primary",
          onClick: addTarget
        }, {
          default: _withCtx(() => [...(_cache[0] || (_cache[0] = [_createTextVNode("新增", -1)]))]),
          _: 1
        })]),
        _: 1
      }), _createElementVNode("div", _hoisted_2, [_createVNode(_component_el_table, {
        data: _unref(tableData),
        style: {
          "width": "100%",
          "height": "100%"
        },
        stripe: ""
      }, {
        default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(header, (v, i) => {
          return _createVNode(_component_el_table_column, _mergeProps({
            ref_for: true
          }, v), {
            default: _withCtx(({
              row,
              $index
            }) => [v.prop == '' ? (_openBlock(), _createElementBlock("span", _hoisted_3, [!row.isEdit ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              title: "编辑",
              src: require('@/assets/images/evaluationRule/edit.png'),
              alt: "",
              onClick: $event => editFn(row)
            }, null, 8, _hoisted_4)) : (_openBlock(), _createElementBlock("img", {
              key: 1,
              title: "保存",
              src: require('@/assets/images/evaluationRule/submit.png'),
              alt: "",
              onClick: $event => submitAdd(row)
            }, null, 8, _hoisted_5)), _createElementVNode("img", {
              title: "删除",
              src: require('@/assets/images/evaluationRule/delete.png'),
              alt: "",
              onClick: $event => deleteItem(row)
            }, null, 8, _hoisted_6)])) : (_openBlock(), _createElementBlock("span", _hoisted_7, [row.isEdit ? (_openBlock(), _createBlock(_component_el_input, {
              key: 0,
              modelValue: row[v.prop],
              "onUpdate:modelValue": $event => row[v.prop] = $event,
              placeholder: '请输入' + v.label
            }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"])) : (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(row[v.prop]), 1))]))]),
            _: 2
          }, 1040);
        }), 64))]),
        _: 1
      }, 8, ["data"])])]);
    };
  }
};